module.exports = __webpack_public_path__ + "media/common/images/favicon-88787a5dd80a2a48041694fe336e813d.png";